
function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}

function toCapitalize(value) {
    return value[0].toUpperCase() + value.substring(1);
}

function transformFromCondition(data, resource) {

    if (resource.code && resource.code.coding) {
        for (var i = 0; i < resource.code.coding.length && i < 1; i += 1) {
            var code = resource.code.coding[i];
            code.display = code.display || resource.code.text;

            var qr = {
                "linkId": "/conditions",
                "text": "Medical Conditions",
                "item": [{
                    "linkId": "/conditions/condition",
                    "text": "Medical condition",
                    "answer": [
                        {
                            "valueCoding": code,
                        }
                    ]
                },
                ]
            };

            if (resource.onsetDateTime) {
                qr.item.push({
                    "linkId": "/conditions/cond_started",
                    "text": "Started",
                    "answer": [
                        {
                            "valueDate": resource.onsetDateTime
                        }
                    ]
                });
            } else if (resource.onsetPeriod && resource.onsetPeriod.start) {
                qr.item.push({
                    "linkId": "/conditions/cond_started",
                    "text": "Started",
                    "answer": [
                        {
                            "valueDate": resource.onsetPeriod.start
                        }
                    ]
                });
            }

            if (resource.clinicalStatus && resource.clinicalStatus.coding && resource.clinicalStatus.coding.length > 0) {
                qr.item.push({
                    "linkId": "/conditions/cond_status",
                    "text": "Status",
                    "answer": [
                        {
                            "valueCoding": resource.clinicalStatus.coding[0]
                        }
                    ]
                });
            }

            if (code.system != "http://terminology.hl7.org/CodeSystem/data-absent-reason" || code.code != "error") {
                data.item.push(qr);
            }
        }
    }
}

function transformFromPatient(data, resource) {

    var demographics = {
        "text": "Demographics",
        "item": []
    };
    var contact = {
        "text": "Contact",
        "item": []
    };
    var address = {
        "text": "Address",
        "item": []
    };

    var name = resource.name;
    if (name && name.length > 0) {
        name = name.find(a => a.use != "old");
        if (name.family) {
            demographics.item.push({
                linkId: "/demographics/last_name",
                text: "Last Name",
                answer: [{
                    valueString: name.family
                }]
            });
        }

        if (name.given && name.given.length > 0) {
            demographics.item.push({
                linkId: "/demographics/first_name",
                text: "First Name",
                answer: [{
                    valueString: name.given[0]
                }]
            });
        }
        if (name.given && name.given.length > 1) {
            demographics.item.push({
                linkId: "/demographics/middle_name",
                text: "Middle Name",
                answer: [{
                    valueString: name.given[1]
                }]
            });
        }
    }

    if (resource.birthDate) {
        demographics.item.push({
            linkId: "/demographics/date_of_birth",
            text: "Date of Birth",
            answer: [{
                valueDate: resource.birthDate
            }]
        });
    }

    if (resource.gender) {
        var gender = toCapitalize(resource.gender);
        demographics.item.push({
            linkId: "/demographics/gender",
            text: "Gender",
            answer: [{
                valueCoding: {
                    code: gender[0],
                    display: gender
                }
            }]
        });
    }

    var hasHomePhone = false;
    var hasMobilePhone = false;
    var hasEmail = false;
    var telecom = resource.telecom;
    if (telecom && telecom.length > 0) {
        telecom.forEach(c => {
            if (c.system == "phone" && c.use == "home" && hasHomePhone == false) {
                hasHomePhone = true;
                contact.item.push({
                    linkId: "/contact/home",
                    text: "Home Phone",
                    answer: [{
                        valueString: c.value
                    }]
                });
            }
            if (c.system == "phone" && c.use == "mobile" && hasMobilePhone == false) {
                hasMobilePhone = true;
                contact.item.push({
                    linkId: "/contact/mobile",
                    text: "Mobile Phone",
                    answer: [{
                        valueString: c.value
                    }]
                });
            }
            if (c.system == "email" && hasEmail == false) {
                hasEmail = true;
                contact.item.push({
                    linkId: "/contact/email",
                    text: "Email",
                    answer: [{
                        valueString: c.value
                    }]
                });
            }
        });
    }

    if (resource.address && resource.address.length > 0) {
        var home = resource.address.find(a => a.use != "old");
        if (home) {
            if (home.line && home.line.length > 0) {
                address.item.push({
                    linkId: "/address/line1",
                    text: "Line 1",
                    answer: [{
                        valueString: home.line[0]
                    }]
                });
            }
            if (home.line && home.line.length > 1) {
                address.item.push({
                    linkId: "/address/line2",
                    text: "Line 2",
                    answer: [{
                        valueString: home.line[1]
                    }]
                });
            }
            if (home.city) {
                address.item.push({
                    linkId: "/address/city",
                    text: "City",
                    answer: [{
                        valueString: home.city
                    }]
                });
            }
            if (home.state) {
                address.item.push({
                    linkId: "/address/state",
                    text: "State",
                    answer: [{
                        valueString: home.state
                    }]
                });
            }
            if (home.postalCode) {
                address.item.push({
                    linkId: "/address/zip",
                    text: "Zip code",
                    answer: [{
                        valueString: home.postalCode
                    }]
                });
            }
        }
    }

    data.item.push(demographics);
    data.item.push(contact);
    data.item.push(address);
}

function transformFromMedicationRequest(data, resource, entries) {

    var homeMedication = true;
    if (resource.category && resource.category.length > 0 && (resource.category[0].text == "Inpatient" || (
        resource.category[0].coding && resource.category[0].coding.length > 0 && resource.category[0].coding[0] &&
        resource.category[0].coding[0].code == 'inpatient'))) {
        homeMedication = false;
    } else if (resource.category && resource.category.length > 0 && (resource.category[0].text == "Outpatient" || (
        resource.category[0].coding && resource.category[0].coding.length > 0 && resource.category[0].coding[0] &&
        resource.category[0].coding[0].code == 'outpatient'))) {
        homeMedication = false;
    }

    if (homeMedication) {
        // only import home medications
        let text = medicationTextFromRequest(resource, entries);
        if (text) {
            var qr = {
                "linkId": "/medications",
                "text": "Medications",
                "item": [
                    {
                        "linkId": "/medications/med_name",
                        "text": "Medication name",
                        "answer": [
                            {
                                "valueCoding": {
                                    "code": text,
                                    "display": text
                                }
                            }
                        ]
                    },
                    {
                        "linkId": "/medications/med_status",
                        "text": "Status",
                        "answer": [
                            {
                                "valueCoding": {
                                    "code": "A",
                                    "display": "Active"
                                }
                            }
                        ]
                    }
                ]
            };

            if (resource.dosageInstruction && resource.dosageInstruction.length > 0 &&
                resource.dosageInstruction[0].text) {
                qr.item.push({
                    "linkId": "/medications/med_strength",
                    "text": "Strength",
                    "answer": [
                        {
                            "valueCoding": {
                                "display": resource.dosageInstruction[0].text
                            }
                        }
                    ]
                });
            }
            if (resource.dosageInstruction && resource.dosageInstruction.length > 0 &&
                resource.dosageInstruction[0].patientInstruction) {
                qr.item.push({
                    "linkId": "/medications/med_instructions",
                    "text": "Instructions",
                    "answer": [
                        {
                            "valueString": resource.dosageInstruction[0].patientInstruction
                        }
                    ]
                });
            }

            data.item.push(qr);
        }
    }
}

function medicationTextFromRequest(resource, entries) {
    if (resource.medicationReference && resource.medicationReference.reference) {
        var mr = entries.find(mr => mr.fullUrl.endsWith(resource.medicationReference.reference));
        if (mr) {
            //AHS240516 - what is mr?
            //AHS240516 - copied from Patrick's wallet
            if (mr.resource) {
                mr = mr.resource;
            }
            var text = resource.medicationReference.display;
            if (!text && mr.code && mr.code.text) {
                text = mr.code.text;
            }
            return text;
        }
    }

    if (resource.medicationReference && resource.medicationReference.display) {
        return resource.medicationReference.display;
    }

    if (resource.medicationCodeableConcept) {
        var text = resource.medicationCodeableConcept.text;
        if (!text && resource.medicationCodeableConcept.coding && resource.medicationCodeableConcept.coding.length > 0 && resource.medicationCodeableConcept.coding[0].display) {
            text = resource.medicationCodeableConcept.coding[0].display;
        }

        return text;
    }

    return null;
}

function transformFromProcedure(data, resource) {

    if (resource.code) {
        var text = resource.code.text;
        if (!text && resource.code.coding && resource.code.coding.length > 0 && resource.code.coding[0].display) {
            text = resource.code.coding[0].display;
        }

        if (text) {
            var qr = {
                "linkId": "/procedures",
                "text": "Major Surgeries and Implants",
                "item": [
                    {
                        "linkId": "/procedures/procedure",
                        "text": "Surgery or Implant",
                        "answer": [
                            {
                                "valueCoding": {
                                    "display": text
                                }
                            }
                        ]
                    }]
            };

            if (resource.performedDateTime) {
                qr.item.push({
                    "linkId": "/procedures/procedure_date",
                    "text": "When done",
                    "answer": [
                        {
                            "valueDate": resource.performedDateTime.substring(0, 10)
                        }
                    ]
                });
            } else if (resource.performedPeriod && resource.performedPeriod.start) {
                qr.item.push({
                    "linkId": "/procedures/procedure_date",
                    "text": "When done",
                    "answer": [
                        {
                            "valueDate": resource.performedPeriod.start.substring(0, 10)
                        }
                    ]
                });
            }


            data.item.push(qr);
        }
    }
}

//AHS240516 - copied from Patrick's wallet
function transformFromImmunization(data, resource) {
    resource.code = resource.code || resource.vaccineCode;
    if (resource.code) {
        var text = resource.code.text;
        if (!text && resource.code.coding && resource.code.coding.length > 0 && resource.code.coding[0].display) {
            text = resource.code.coding[0].display;
        }

        if (text) {
            var qr = {
                "linkId": "/vaccinations",
                "text": "Vaccinations",
                "item": [
                    {
                        "linkId": "/vaccinations/vaccine_name",
                        "text": "Vaccine name",
                        "answer": [
                            {
                                "valueCoding": {
                                    "display": text
                                }
                            }
                        ]
                    }]
            };

            if (resource.performedDateTime) {
                qr.item.push({
                    "linkId": "/vaccinations/vaccine_date",
                    "text": "Date",
                    "answer": [
                        {
                            "valueDate": resource.performedDateTime.substring(0, 10)
                        }
                    ]
                });
            } else if (resource.performedPeriod && resource.performedPeriod.start) {
                qr.item.push({
                    "linkId": "/vaccinations/vaccine_date",
                    "text": "Date",
                    "answer": [
                        {
                            "valueDate": resource.performedPeriod.start.substring(0, 10)
                        }
                    ]
                });
            }


            data.item.push(qr);
        }
    }
}

//AHS240516 - copied from Patrick's wallet
function transformFromCoverage(data, resource) {

    var mn = resource.identifier.find(i => i.type && i.type.coding && i.type.coding.find(c => c.code = 'MB') != null);

    var sub = null;
    if (resource.subscriber && resource.subscriber.display) {
        sub = resource.subscriber.display;
    }

    var payor = null;
    if (resource.payor && resource.payor && resource.payor.length > 0 && resource.payor[0].display) {
        payor = resource.payor[0].display;
    }

    var relationship = null;
    if (resource.relationship && resource.relationship.coding && resource.relationship.coding.length > 0) {
        relationship = resource.relationship.coding[0];
    }

    if (mn || sub) {
        var qr = {
            "linkId": "/coverage",
            "text": "Insurance Coverage",
            "item": []
        };

        if (mn) {
            qr.item.push(
                {
                    "linkId": "/coverage/subscriber_id",
                    "text": "Subscriber Id",
                    "answer": [
                        {
                            "valueString": mn.value
                        }
                    ]
                });
        }

        if (sub) {
            qr.item.push(
                {
                    "linkId": "/coverage/subscriber_name",
                    "text": "Subscriber Name",
                    "answer": [
                        {
                            "valueString": sub
                        }
                    ]
                });
        }

        if (payor) {
            qr.item.push(
                {
                    "linkId": "/coverage/payor",
                    "text": "Insurer",
                    "answer": [
                        {
                            "valueString": payor
                        }
                    ]
                });
        }

        if (relationship) {
            qr.item.push(
                {
                    "linkId": "/coverage/relationship",
                    "text": "Relationship",
                    "answer": [
                        {
                            "valueCoding": relationship
                        }
                    ]
                });
        }

        if (resource.period && resource.period.start) {
            qr.item.push({
                "linkId": "/coverage/started",
                "text": "Started",
                "answer": [
                    {
                        "valueDate": resource.period.start.substring(0, 10)
                    }
                ]
            });
        }

        data.item.push(qr);
    }
}

//AHS240516 - copied from Patrick's wallet
function transformFromPractitioner(data, resource) {
    if (resource.profile) {
        var qr = {
            "linkId": "/providers",
            "text": "Medical Providers",
            "item": [
                {
                    "linkId": "/providers/contact_name",
                    "text": "Name",
                    "answer": [
                        {
                            "valueString": resource.profile.name
                        }
                    ]
                },
                {
                    "linkId": "/providers/contact_type",
                    "text": "Type",
                    "answer": [
                        {
                            "valueString": resource.profile.specialty
                        }
                    ]
                },
                {
                    "linkId": "/providers/contact_phone",
                    "text": "Telephone",
                    "answer": [
                        {
                            "valueString": resource.profile.office_phone
                        }
                    ]
                },
                {
                    "linkId": "/contacts/contact_comment",
                    "text": "Comment",
                    "answer": [
                        {
                            "valueString": resource.profile.practice
                        }
                    ]
                }
            ]
        };
        data.item.push(qr);
    } else if (resource.name && resource.name.length > 0 && resource.name[0] && resource.name[0].text) {
        var qr = {
            "linkId": "/providers",
            "text": "Medical Providers",
            "item": [
                {
                    "linkId": "/providers/contact_name",
                    "text": "Name",
                    "answer": [
                        {
                            "valueString": resource.name[0].text
                        }
                    ]
                }]
        };
        data.item.push(qr);
    }
}

function transformFromResource(data, resource, entries) {
    // console.log(resource.resourceType);

    if (resource.resourceType == "Condition") {
        transformFromCondition(data, resource);
    } else if (resource.resourceType == "Patient") {
        transformFromPatient(data, resource);
    } else if (resource.resourceType == "MedicationRequest") {
        transformFromMedicationRequest(data, resource, entries);
    } else if (resource.resourceType == "Procedure") {
        transformFromProcedure(data, resource);
    } else if (resource.resourceType == "Practitioner") {
        transformFromPractitioner(data, resource);
    } else if (resource.resourceType == "Immunization") {
        transformFromImmunization(data, resource);
    } else if (resource.resourceType == "Coverage") {
        transformFromCoverage(data, resource);
    } else {
        console.log('todo', resource.resourceType);
    }
}

function transformFromEnry(data, entry, entries) {
    transformFromResource(data, entry.resource, entries);
}

function transformFromResourceToQuestionnaireResponse(resource) {

    var qr = {
        authored: new Date().toISOString(),
        item: [],
        resourceType: "QuestionnaireResponse",
        status: "completed"
    };

    if (resource.resourceType == "Bundle") {
        for (var i = 0; i < resource.entry.length; i += 1) {
            transformFromEnry(qr, resource.entry[i], resource.entry);
        }
    } else if (resource.resourceType) {
        transformFromResource(qr, resource, []);
    } else if (resource.resource) {
        transformFromResource(qr, resource.resource, []);
    } else {
        // todo
    }

    return qr;
}

function answerForLinkId(items, linkId) {
    var answer = items.find((i) => i.linkId == linkId);
    if (!answer || !answer.answer || answer.answer.length == 0) {
        return null;
    }

    answer = answer.answer[0];
    if (answer.valueString) {
        return answer.valueString;
    } else if (answer.valueDate) {
        return answer.valueDate;
    } else if (answer.valueCoding) {
        return answer.valueCoding;
    }

    return null;
}

function transformCondition(now, patient, c) {
    var ret = {
        id: uuidv4(),
        resourceType: "Condition",
        category: [
            {
                coding: [
                    {
                        system: "http://snomed.info/sct",
                        code: "55607006",
                        display: "Problem",
                    },
                    {
                        system: "http://terminology.hl7.org/CodeSystem/condition-category",
                        code: "problem-list-item",
                    },
                ],
            },
        ],
        subject: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
        recordedDate: now,
    };

    var condition = answerForLinkId(c.item, "/conditions/condition");
    var started = answerForLinkId(c.item, "/conditions/cond_started");
    var stopped = answerForLinkId(c.item, "/conditions/cond_stopped");
    var status = answerForLinkId(c.item, "/conditions/cond_status");
    var comment = answerForLinkId(c.item, "/conditions/cond_comment");

    if (condition) {
        ret.code = {
            coding: [
                {
                    system: "http://hl7.org/fhir/sid/icd-10-cm",
                    code: condition.code,
                    display: condition.display,
                },
            ],
        };
    }

    if (status) {
        ret.clinicalStatus = {
            coding: [
                {
                    system: "http://terminology.hl7.org/CodeSystem/condition-clinical",
                    code: status.display.toLowerCase(),
                },
            ],
        };
    }

    if (started) {
        ret.onsetDateTime = started;
    }

    if (stopped) {
        ret.abatementDateTime = stopped;
    }

    if (comment) {
        ret.note = [
            {
                text: comment,
            },
        ];
    }

    return ret;
}

function transformProcedure(now, patient, r) {
    var ret = {
        id: uuidv4(),
        resourceType: "Procedure",
        subject: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
        recordedDate: now,
    };

    var procedure = answerForLinkId(r.item, "/procedures/procedure");
    var date = answerForLinkId(r.item, "/procedures/procedure_date");
    var comment = answerForLinkId(r.item, "/procedures/cond_comment");

    if (procedure) {
        ret.code = {
            coding: [
                {
                    display: procedure.display,
                },
            ],
        };

        if (procedure.code) {
            ret.code.coding[0].system = "http://hl7.org/fhir/sid/icd-9-cm";
            ret.code.coding[0].code = procedure.code.substring(0, 2) + "." + procedure.code.substring(2);

        }
    }

    if (status) {
        ret.clinicalStatus = {
            coding: [
                {
                    system: "http://terminology.hl7.org/CodeSystem/condition-clinical",
                    code: status.display.toLowerCase(),
                },
            ],
        };
    }

    if (date) {
        ret.occurrenceDateTime = date;
    }

    if (comment) {
        ret.note = [
            {
                text: comment,
            },
        ];
    }

    return ret;
}

//AHS240516 - insurance is the same as coverage
function transformCoverage(now, patient, r) {
    var ret = {
        id: uuidv4(),
        resourceType: "Coverage",
        subject: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
        recordedDate: now,
    };

    var payor = answerForLinkId(r.item, "/coverage/payor");
    var subscriber_name = answerForLinkId(r.item, "/coverage/subscriber_name");
    var subscriber_id = answerForLinkId(r.item, "/coverage/subscriber_id");
    var relationship = answerForLinkId(r.item, "/coverage/relationship");
    var started = answerForLinkId(r.item, "/coverage/started");
    var ended = answerForLinkId(r.item, "/coverage/ended");

    if (payor) {
        ret.payor = {
            display: payor,
        };
    }
    if (started || ended) {
        ret.period = {
            start: started,
            end: ended
        };
    }
    if (subscriber_id) {
        ret.identifier = [{
            "type": {
                "coding": [
                  {
                    "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                    "code": "MB",
                    "display": "Member Number"
                  }
                ]
              },
              "value": subscriber_id
        }];
    }

    if (subscriber_name) {
        ret.subscriber = {
            display: subscriber_name,
        };
    }

    if (relationship) {
        ret.relationship = relationship;
    }

    return ret;
}

function transformPractitioner(now, patient, r) {
    let ret = {
        id: uuidv4(),
        resourceType: "Provider",
        subject: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
        status: "current", //? What are the possible values of status?
        title: "Medical Providers",
    };

    var name = answerForLinkId(r.item, "/providers/contact_name");
    var specialty = answerForLinkId(r.item, "/providers/contact_type");
    var office_phone = answerForLinkId(r.item, "/providers/contact_phone");
    var fax = answerForLinkId(r.item, "/providers/contact_fax");
    var email = answerForLinkId(r.item, "/providers/contact_email");
    var appt = answerForLinkId(r.item, "/providers/contact_appt");
    var appt_time = answerForLinkId(r.item, "/providers/contact_appt_time");
    var practice = answerForLinkId(r.item, "/contacts/contact_comment");

    ret.profile = {};

    if(name) {
        ret.profile.name = name;
    }

    if(specialty) {
        ret.profile.specialty = specialty;
    }

    if(office_phone) {
        ret.profile.office_phone = office_phone;
    }

    if(fax) {
        ret.profile.fax = fax;
    }

    if(email) {
        ret.profile.email = email;
    }

    if(appt) {
        ret.profile.appt = appt;
    }

    if(appt_time) {
        ret.profile.appt_time = appt_time;
    }

    if(practice) {
        ret.profile.practice = practice;
    }

    return ret;
}

function transformAllergy(now, patient, r) {
    var name = answerForLinkId(r.item, "/allergies/allergy_name");
    var reaction = answerForLinkId(r.item, "/allergies/allergy_reaction");
    var started = answerForLinkId(r.item, "/allergies/allergy_started");
    var comment = answerForLinkId(r.item, "/allergies/allergy_comment");

    var ret = {
        id: uuidv4(),
        resourceType: "AllergyIntolerance",
        assertedDate: now,
        type: "allergy",
        patient: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
    };

    if (name) {
        ret.code = {
            coding: [
                {
                    system: "Custom",
                    code: name.code,
                    display: name.display,
                },
            ],
        };
    }

    if (started) {
        ret.onsetDateTime = started;
    }

    if (reaction) {
        ret.reaction = [
            {
                manifestation: [
                    {
                        coding: [
                            {
                                display: reaction.display,
                                code: reaction.code,
                                system: "Custom",
                            },
                        ],
                    },
                ],
            },
        ];
    }

    if (comment) {
        ret.note = [
            {
                text: comment,
            },
        ];
    }

    return ret;
}

function transformMedication(now, patient, r) {
    var name = answerForLinkId(r.item, "/medications/med_name");
    var status = answerForLinkId(r.item, "/medications/med_status");
    var strength = answerForLinkId(r.item, "/medications/med_strength");
    var instructions = answerForLinkId(r.item, "/medications/med_instructions");
    var started = answerForLinkId(r.item, "/medications/med_started");
    var stopped = answerForLinkId(r.item, "/medications/med_stopped");
    var why_stopped = answerForLinkId(r.item, "/medications/med_why_stopped");
    var resupply = answerForLinkId(r.item, "/medications/med_resupply");

    var ret = {
        id: uuidv4(),
        resourceType: "MedicationStatement",
        subject: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
        informationSource: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
    };

    if (strength) {
        var display = name.display + " " + strength.display;
        ret.medicationCodeableConcept = {
            coding: [
                {
                    system: "http://www.nlm.nih.gov/research/umls/rxnorm",
                    code: strength.code,
                    display: display,
                },
            ],
            text: display,
        };
    } else if (name) {
        var display = name.display;
        ret.medicationCodeableConcept = {
            text: display,
        };
    }

    if (status) {
        ret.status = status.display.toLowerCase();
    }

    if (started) {
        if (stopped) {
            ret.effectivePeriod = {
                start: started,
                end: stopped,
            };
        } else {
            ret.effectiveDateTime = started;
        }
    }

    if (instructions) {
        ret.dosage = [
            {
                text: instructions,
            },
        ];
    }

    return ret;
}

function transformImmunization(now, patient, r) {
    var name = answerForLinkId(r.item, "/vaccinations/vaccine_name");
    var date = answerForLinkId(r.item, "/vaccinations/vaccine_date");
    var next = answerForLinkId(r.item, "/vaccinations/vaccine_next");
    var comment = answerForLinkId(r.item, "/vaccinations/vaccine_comment");

    var ret = {
        id: uuidv4(),
        resourceType: "Immunization",
        status: "completed",
        patient: {
            reference: "urn:uuid:" + patient.id,
            display: patient.display,
        },
    };

    if (name) {
        ret.vaccineCode = {
            coding: [
                {
                    system: "http://hl7.org/fhir/sid/cvx",
                    code: name.code,
                    display: name.display,
                },
            ],
        };
    }

    if (date) {
        ret.occurrenceDateTime = date;
    }

    if (next) {
        /// TODO, how/where to store? extension?
        ret.next = next;
    }

    if (comment) {
        ret.note = [
            {
                text: comment,
            },
        ];
    }

    return ret;
}

function transformAllergiesToList(now, patient, allergies) {
    var ret = {
        id: uuidv4(),
        resourceType: "List",
        status: "current",
        title: "Active Allergies",
        code: {
            coding: [
                {
                    display: "Allergies and adverse reaction",
                    system: "http://snomed.info/sct",
                    code: "886921000000105",
                },
            ],
        },
        entry: allergies.map((a) => {
            return {
                item: {
                    reference: "urn:uuid:" + a.id,
                },
            };
        }),
        date: now,
        mode: "snapshot",
        orderedBy: {
            coding: [
                {
                    system: "http://hl7.org/fhir/list-order",
                    code: "event-date",
                },
            ],
        },
        subject: {
            reference: "urn:uuid:" + patient.id,
        },
    };

    return ret;
}

function transformFromQuestionnaireResponseToBundle(qr) {
    var items = qr.item || [];
    var now = new Date().toISOString();

    var demographics = items.find((q) => q.text == "Demographics") || {
        item: [],
    };
    demographics = demographics.item;

    var display = "";
    var names = [];
    if (demographics.length > 0) {
        var last_name = answerForLinkId(demographics, "/demographics/last_name");
        var name = {
            use: "official",
            family: last_name,
            given: [],
        };

        var first = answerForLinkId(demographics, "/demographics/first_name");
        var middle = answerForLinkId(demographics, "/demographics/middle_name");

        if (first) {
            name.given.push(first);
            display += first;
            if (middle) {
                name.given.push(middle);
                display += " ";
                display += middle;
            }
            if (last_name) {
                display += " ";
            }
        }
        if (last_name) {
            display += last_name;
        }
        names.push(name);
    }
    var address = items.find((q) => q.text == "Address") || { item: [] };
    address = address.item;

    var addresses = [];
    if (address.length > 0) {
        var home = {
            use: "home",
            type: "both",
            text: "",
            line: [],
            city: answerForLinkId(address, "/address/city"),
            state: answerForLinkId(address, "/address/state"),
            postalCode: answerForLinkId(address, "/address/zip"),
        };

        var line1 = answerForLinkId(address, "/address/line1");
        var line2 = answerForLinkId(address, "/address/line2");

        if (line1) {
            home.line.push(line1);
            if (line2) {
                home.line.push(line2);
            }
        }

        home.text =
            home.line.join(" ") +
            " " +
            home.city +
            ", " +
            home.state +
            " " +
            home.postalCode;
        addresses.push(home);
    }

    var telecom = [];
    var contact = items.find((q) => q.text == "Contact") || { item: [] };
    contact = contact.item;
    if (contact.length > 0) {
        var email = answerForLinkId(contact, "/contact/email");
        var mobile = answerForLinkId(contact, "/contact/mobile");
        var home = answerForLinkId(contact, "/contact/home");

        if (mobile) {
            var tel = {
                system: "phone",
                value: mobile,
                use: "mobile",
            };
            telecom.push(tel);
        }

        if (home) {
            var tel = {
                system: "phone",
                value: home,
                use: "home",
            };
            telecom.push(tel);
        }

        if (email) {
            var tel = {
                system: "email",
                value: email,
            };
            telecom.push(tel);
        }
    }

    var dob = answerForLinkId(demographics, "/demographics/date_of_birth");
    var genderCode = answerForLinkId(demographics, "/demographics/gender");
    var gender = null;
    if (genderCode && genderCode.display) {
        gender = genderCode.display.toLowerCase();
    }

    var patient = {
        resourceType: "Patient",
        id: uuidv4(),
        identifier: [],
        active: true,
        name: names,
        telecom: telecom,
        gender: gender,
        birthDate: dob,
        deceasedBoolean: false,
        address: addresses,
        display: display,
    };

    var allergies = items
        .filter((q) => q.linkId == "/allergies")
        .map((r) => transformAllergy(now, patient, r));
    var allergiesList = transformAllergiesToList(now, patient, allergies);
    var conditions = items
        .filter((q) => q.linkId == "/conditions")
        .map((r) => transformCondition(now, patient, r));
    var immunization = items
        .filter((q) => q.linkId == "/vaccinations")
        .map((r) => transformImmunization(now, patient, r));
    var medications = items
        .filter((q) => q.linkId == "/medications")
        .map((r) => transformMedication(now, patient, r));
    var procedures = items
        .filter((q) => q.linkId == "/procedures")
        .map((r) => transformProcedure(now, patient, r));
    var providers = items
        .filter((q) => q.linkId == "/providers")
        .map((r) => transformPractitioner(now, patient, r));
    var coverage = items
        .filter((q) => q.linkId == "/coverage")
        .map((r) => transformCoverage(now, patient, r));

    var entry = [
        {
            fullUrl: "urn:uuid:" + patient.id,
            resource: patient,
        },
        {
            fullUrl: "urn:uuid:" + allergiesList.id,
            resource: allergiesList,
        },
    ];

    //are we replacing providers with coverage?
    [conditions, allergies, immunization, medications, procedures, providers, coverage]
        .flat()
        .forEach((c) => {
            entry.push({
                fullUrl: "urn:uuid:" + c.id,
                resource: c,
            });
        });

    delete patient.display;

    var bundle = {
        id: uuidv4(),
        resourceType: "Bundle",
        meta: {
            lastUpdated: now,
        },
        timestamp: now,
        type: "collection",
        entry: entry,
    };
    return bundle;
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports.answerForLinkId = answerForLinkId;
}
